// Author Liu Cui Cui
// Date 2023-07-06 16:22:17

class SithMesMstMaterialDrawing {
    constructor({
                    id = null,
                    mmdMaterialCode = '',
                    mmdChildMaterialCode = '',
                    mmdDrawingType = '',
                    mmdDrawingName = '',
                    mmdDrawingDesigner = '',
                    mmdDrawingTechnologistId = '',
                    mmdDrawingTechnologist = '',
                    mmdDrawingVersion = '',
                    mmdDrawingDescription = '',
                    mmdDrawingNumber = '',
                    mmdDrawingPart = '',
                    mmdDrawingApplication = '',
                    mmdDrawingUri = '',
                    mmdUploadTime = '',
                    mmdDownloadTime = '',
                    mmdOperatorId = '',
                    mmdDrawingFileIds = '',
                    mmdUpdateTimeRecorder = '',
                    mmdUsageState = '',
                    remark = '',
                    mmdDrawingFiles = ''
                }
                    = {}) {
        this.id = id;
        this.mmdMaterialCode = mmdMaterialCode;
        this.mmdChildMaterialCode = mmdChildMaterialCode;
        this.mmdDrawingType = mmdDrawingType;
        this.mmdDrawingName = mmdDrawingName;
        this.mmdDrawingDesigner = mmdDrawingDesigner;
        this.mmdDrawingTechnologistId = mmdDrawingTechnologistId;
        this.mmdDrawingTechnologist = mmdDrawingTechnologist;
        this.mmdDrawingVersion = mmdDrawingVersion;
        this.mmdDrawingDescription = mmdDrawingDescription;
        this.mmdDrawingNumber = mmdDrawingNumber;
        this.mmdDrawingPart = mmdDrawingPart;
        this.mmdDrawingApplication = mmdDrawingApplication;
        this.mmdDrawingUri = mmdDrawingUri;
        this.mmdUploadTime = mmdUploadTime;
        this.mmdDownloadTime = mmdDownloadTime;
        this.mmdOperatorId = mmdOperatorId;
        this.mmdDrawingFileIds = mmdDrawingFileIds;
        this.mmdUpdateTimeRecorder = mmdUpdateTimeRecorder;
        this.mmdUsageState = mmdUsageState;
        this.remark = remark;
        this.mmdDrawingFiles = mmdDrawingFiles;
    }
}

function newEntity() {
    return new SithMesMstMaterialDrawing();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdMaterialCode',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdMaterialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdChildMaterialCode',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdChildMaterialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingType',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingName',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingDesigner',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingDesigner',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingTechnologist',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingTechnologist',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingVersion',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingVersion',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingDescription',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingNumber',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingPart',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingPart',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingApplication',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingApplication',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingUri',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingUri',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdUploadTime',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdUploadTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDownloadTime',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDownloadTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdOperator',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdOperator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdDrawingFiles',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdDrawingFiles',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdUpdateTimeRecorder',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdUpdateTimeRecorder',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'mmdUsageState',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.mmdUsageState',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '上工展示用'},
                    {value: '2', text: '采购用'},
                    {value: '3', text: '质检用'}
                ]
            }
        },
        {
            key: 'remark',
            label: 'label.sith.mst.sithMesMstMaterialDrawing.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    mmdMaterialCodeFilter: '',
    mmdChildMaterialCodeFilter: '',
    mmdDrawingTypeFilter: '',
    mmdDrawingNameFilter: '',
    mmdDrawingDesignerFilter: '',
    mmdDrawingTechnologistIdFilter: '',
    mmdDrawingTechnologistFilter: '',
    mmdDrawingVersionFilter: '',
    mmdDrawingDescriptionFilter: '',
    mmdDrawingNumberFilter: '',
    mmdDrawingPartFilter: '',
    mmdDrawingApplicationFilter: '',
    mmdDrawingUriFilter: '',
    mmdUploadTimeRteFilter: '',
    mmdUploadTimeLteFilter: '',
    mmdDownloadTimeRteFilter: '',
    mmdDownloadTimeLteFilter: '',
    mmdOperatorIdFilter: '',
    mmdOperatorFilter: '',
    mmdUpdateTimeRecorderFilter: '',
    mmdUsageStateFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'mmdMaterialCodeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdMaterialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdChildMaterialCodeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdChildMaterialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingNameFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingDesignerFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingDesigner',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingTechnologistFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingTechnologist',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingVersionFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingVersion',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingDescriptionFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingDescription',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingPartFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingPart',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingApplicationFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingApplication',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingUriFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDrawingUri',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUploadTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdUploadTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUploadTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdUploadTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDownloadTimeRteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDownloadTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDownloadTimeLteFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdDownloadTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdOperatorFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdOperator',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUpdateTimeRecorderFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdUpdateTimeRecorder',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUsageStateFilter',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.filter.mmdUsageState',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '上工展示用'},
                {value: '2', text: '采购用'},
                {value: '3', text: '质检用'}
            ]
        }
    }
];


const entityFormConfigs = [
    {
        key: 'mmdMaterialCode',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdMaterialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdChildMaterialCode',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdChildMaterialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingType',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingName',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingDesigner',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingDesigner',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingTechnologist',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingTechnologist',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"mmdDrawingTechnologistId":"id"}'
        }
    },
    {
        key: 'mmdDrawingVersion',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingVersion',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingDescription',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingDescription',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingNumber',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingPart',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingPart',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingApplication',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingApplication',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingUri',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingUri',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUploadTime',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdUploadTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDownloadTime',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDownloadTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUpdateTimeRecorder',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdUpdateTimeRecorder',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdUsageState',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdUsageState',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '上工展示用'},
                {value: '2', text: '采购用'},
                {value: '3', text: '质检用'}
            ]
        }
    },
    {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'mmdDrawingFiles',
        label: 'label.sith.mst.sithMesMstMaterialDrawing.entity.mmdDrawingFileIds',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'mmdDrawingFileIds'
        }
    }
]

export {
    SithMesMstMaterialDrawing, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
